/**
 * AJAX add-to-cart for LUPZ catalog forms (Shop all + collection pages).
 * Opens the cart drawer and refreshes the header badge after a successful add.
 */
(function () {
  if (window.__lupzCartAtcBound) return;
  window.__lupzCartAtcBound = true;

  const defaultLabel =
    (window.theme && window.theme.locales && window.theme.locales.product && window.theme.locales.product.add_to_cart) ||
    'Add to Cart';

  function cartAddUrl() {
    const routes = window.Shopify && window.Shopify.routes;
    return routes && routes.cart_add_url ? `${routes.cart_add_url}.js` : '/cart/add.js';
  }

  function cartPageUrl() {
    const routes = window.Shopify && window.Shopify.routes;
    return routes && routes.cart_url ? routes.cart_url : '/cart';
  }

  function findHeaderCartIcon() {
    return (
      document.querySelector('#header-group .nav-icon.position-relative[href="#offcanvas-cart"]') ||
      document.querySelector('#header-group .header__icon--cart') ||
      document.querySelector('#header-group a[href="#offcanvas-cart"]')
    );
  }

  function ensureBadge(icon) {
    if (!icon) return null;

    let badge =
      icon.querySelector('.cart-count-badge') ||
      icon.querySelector('[data-count]') ||
      icon.querySelector('.badge-circle');

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'cart-count-badge badge badge-circle';
      badge.setAttribute('data-count', '0');
      badge.setAttribute('aria-hidden', 'true');
      icon.appendChild(badge);
    }

    return badge;
  }

  function setBadgeCount(count) {
    const n = Number.isFinite(count) && count >= 0 ? count : 0;

    document.documentElement.setAttribute('data-cart-items', String(n));
    document.documentElement.classList.toggle('cart-has-items', n > 0);
    document.documentElement.classList.toggle('cart--has-items', n > 0);
    document.documentElement.classList.toggle('cart--empty', n === 0);

    if (document.body) {
      document.body.classList.toggle('cart-has-items', n > 0);
      document.body.classList.toggle('cart--has-items', n > 0);
      document.body.classList.toggle('cart--empty', n === 0);
    }

    let candidates = Array.from(
      document.querySelectorAll('#header-group .cart-count-badge, #header-group [data-count], #header-group .badge-circle')
    );

    if (!candidates.length) {
      const badge = ensureBadge(findHeaderCartIcon());
      if (badge) candidates = [badge];
    }

    for (const badge of candidates) {
      badge.textContent = n > 0 ? String(n) : '';
      if (badge.hasAttribute('data-count')) badge.setAttribute('data-count', String(n));
      badge.setAttribute('aria-hidden', n > 0 ? 'false' : 'true');
      if (n > 0) {
        badge.style.display = '';
        badge.removeAttribute('hidden');
      } else {
        badge.style.display = 'none';
      }
    }
  }

  function refreshCartCountFromServer() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then((res) => {
        if (!res.ok) throw new Error('cart.js failed');
        return res.json();
      })
      .then((cart) => {
        setBadgeCount(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
      });
  }

  function refreshOffcanvasCart() {
    const offcanvas = document.getElementById('offcanvas-cart');
    if (!offcanvas) return Promise.resolve();

    const url = `${window.location.pathname}?section_id=offcanvas-cart`;

    return fetch(url, {
      method: 'GET',
      headers: { Accept: 'text/html' },
      credentials: 'same-origin',
    })
      .then((res) => {
        if (!res.ok) throw new Error('section fetch failed');
        return res.text();
      })
      .then((html) => {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const fresh = temp.querySelector('#offcanvas-cart');
        offcanvas.innerHTML = fresh ? fresh.innerHTML : html;
      });
  }

  function openCartUI() {
    const offcanvasEl = document.getElementById('offcanvas-cart');

    if (offcanvasEl && window.bootstrap && window.bootstrap.Offcanvas) {
      try {
        window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl).show();
        return;
      } catch (error) {
        console.warn('Offcanvas cart show error', error);
      }
    }

    const trigger =
      document.querySelector('#header-group [data-bs-toggle="offcanvas"][href="#offcanvas-cart"]') ||
      document.querySelector('#header-group [href="#offcanvas-cart"]');

    if (trigger) {
      trigger.click();
      return;
    }

    window.location.href = cartPageUrl();
  }

  function handleSubmit(event) {
    const form = event.target;

    if (!form || !form.matches || !form.matches('form[data-lupz-atc]')) return;

    event.preventDefault();
    event.stopPropagation();

    const submitButton = form.querySelector('button[type="submit"]');
    const originalText = submitButton
      ? submitButton.getAttribute('data-original-text') || submitButton.textContent
      : defaultLabel;

    if (submitButton) {
      submitButton.setAttribute('data-original-text', originalText);
      submitButton.disabled = true;
      submitButton.textContent = 'Adding…';
    }

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: new FormData(form),
      credentials: 'same-origin',
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error((data && data.description) || 'Add to cart failed');
          });
        }
        return response.json();
      })
      .then(() => Promise.all([refreshCartCountFromServer(), refreshOffcanvasCart()]))
      .then(() => {
        if (submitButton) {
          submitButton.textContent = 'Added ✓';
          setTimeout(() => {
            submitButton.disabled = false;
            submitButton.textContent = submitButton.getAttribute('data-original-text') || originalText;
          }, 1400);
        }
        openCartUI();
      })
      .catch((error) => {
        console.error(error);
        if (submitButton) {
          submitButton.textContent = 'Try again';
          setTimeout(() => {
            submitButton.disabled = false;
            submitButton.textContent = submitButton.getAttribute('data-original-text') || originalText;
          }, 1400);
        }
      });
  }

  document.addEventListener('submit', handleSubmit, true);
})();
